import axios from './index';

export default {
    GenerateAuthenticatorQrRegistration,
    PostEnableAuthenticator,
    TwoFactorIsEnabled,
    DisableAuthenticator,
    DisableAuthenticatorByEmail
}

async function GenerateAuthenticatorQrRegistration() {
    const response = await axios.get('/api/v1/Account/authenticator-qrcode');

    return response.data;
}
async function PostEnableAuthenticator({ code }) {
    const response = await axios.post('/api/v1/Account/enable-authenticator', { code });
    return response.data
}

async function DisableAuthenticator() {
    const response = await axios.delete('/api/v1/Account/disable-authenticator');
    return response.status === 200;
}

async function DisableAuthenticatorByEmail({ email }) {
    const response = await axios.post('/api/v1/Account/disable-authenticator', { email });
    return response.status === 200;
}

async function TwoFactorIsEnabled({ email }) {
    const response = await axios.get('/api/v1/Account/two-factor-is-enabled', {
        params: { email }
    });

    return response.data;
}